wbApp.factory('consentSvc', ['$resource', '$q', '$sce', '$translate', 'repositorySvc',
    function ($resource, $q, $sce, $translate, repositorySvc) {
        var Consent = $resource('/Api/Groups/:id', {}, {            
            'getConsentsInfoBrief': { method: 'GET', isArray: true, url: '/Api/Consents/GetConsentsInfoBrief' },
            'getConsentsInfoForUser': { method: 'GET', isArray: false, url: '/Api/Consents/GetConsentsInfoForUser' },
            'assignConsensts': { method: 'POST', url: '/Api/Consents/AssignConsensts' },
            'approveConsent': { method: 'POST', url: '/Api/Consents/ApproveConsent' },
            'rejectConsent': { method: 'POST', url: '/Api/Consents/RejectConsent' },
        });

        function getConsentsInfoBrief() {
            return repositorySvc.customGet('getConsentsInfoBrief', Consent);
        }

        function getConsentsInfoForUser(userID) {
            return repositorySvc.customGet('getConsentsInfoForUser', Consent, {
                userID: userID
            });
        }


        // data: 
        // { 
        //   informUsers: true|false,
        //   consnetIDs: [1,2,3,4],
        //   userIDs: [1,2,3,4]
        // }
        function assignConsensts(data, success, error) {
            return repositorySvc.customPost(
                'assignConsensts',
                Consent,
                data,
                success,
                error
            );
        }

        function approveConsent(consent, success, error) {
            return repositorySvc.customPost(
                'approveConsent',
                Consent,
                { consentID: consent.consentID },
                success,
                error
            );
        }

        function rejectConsent(consent, success, error) {
            return repositorySvc.customPost(
                'rejectConsent',
                Consent,
                { consentID: consent.consentID },
                success,
                error
            );
        }

        return {
            getConsentsInfoBrief: getConsentsInfoBrief,
            getConsentsInfoForUser: getConsentsInfoForUser,
            assignConsensts: assignConsensts,
            approveConsent: approveConsent,
            rejectConsent: rejectConsent
        }
    }]);